// Inline error strip shared by the deploy/runner surfaces: full-border
// destructive tint, mono for technical output, sans for human sentences.
const ErrorStrip = ({
  error,
  mono = true
}: {
  error: string;
  mono?: boolean;
}) => (
  <div className="rounded-lg border border-destructive/30 bg-destructive/[0.06] px-3 py-2">
    <p
      className={`whitespace-pre-wrap break-words leading-relaxed text-destructive ${
        mono ? 'font-mono text-[11px]' : 'text-xs'
      }`}
    >
      {error}
    </p>
  </div>
);

export default ErrorStrip;
